const EDITABLE_SELECTOR = "input, textarea, select, [contenteditable=''], [contenteditable='true']";
const SECONDARY_BUTTON = 2;

/** Text fields keep the browser's own menu (copy, paste). */
export function isEditable(el: Element): boolean {
  return Boolean(el.closest(EDITABLE_SELECTOR));
}

/** True for the keys that open a context menu from the keyboard: Shift+F10 and the Menu key. */
export function isContextMenuKey(e: { key: string; shiftKey: boolean }): boolean {
  return e.key === "ContextMenu" || (e.shiftKey && e.key === "F10");
}

/** A `contextmenu` event the browser fired for a key press rather than a right-click: it has no pointer position. */
export function isKeyboardContextMenu(e: { button: number; clientX: number; clientY: number }): boolean {
  return e.button !== SECONDARY_BUTTON && e.clientX === 0 && e.clientY === 0;
}
